import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export type ContentStackType = {
  title?: string;
  value?: React.ReactNode;
  ellipseValueOnMobile?: boolean;
  valueClassName?: string;
};

export const ContentStack: React.FC<ContentStackType> = ({ title, value, children, ellipseValueOnMobile = false, valueClassName }) => {
  const valueUndefined = value === undefined;
  const { classes, cx } = useContentStackStyles({ valueUndefined });
  const { classes: valueClasses } = useValueStyles();

  const valueDisplay = (
    <>
      <Typography
        className={cx([ classes.value, valueClassName ])}
        classes={valueClasses}
        noWrap={ellipseValueOnMobile}
      >
        {valueUndefined ? 'Optional' : value}
      </Typography>
      {children}
    </>
  );

  if (!title) return valueDisplay;
  return (
    <Box>
      <Typography variant="body1" className={classes.title}>{title}</Typography>
      {valueDisplay}
    </Box>
  );
};

type ContentStackStyleProps = { valueUndefined: boolean };
const useContentStackStyles = makeStyles<ContentStackStyleProps>()((theme, { valueUndefined }) => ({
  title: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(0.5),
      color: theme.palette.text.primary
    }
  },
  value: {
    color:valueUndefined ? theme.palette.text.disabled : theme.palette.text.primary,
  }
}));

const useValueStyles = makeStyles()((theme) => ({
  root: {
    fontWeight: 500,
  },
  noWrap: {
    [theme.breakpoints.down('sm')]: {
      width: '262px',
    }
  }
}));
